import { validate } from "../Validation/validator";
import { BaseForm } from "./BaseForm";

export class SignupForm extends BaseForm {
    firstName = "";
    lastName = "";
    email = "";
    confirm = false;
    errors = {
        password: false,
        passwordConfirm: false,
        email: false,
        firstName: false,
        lastName: false,
        confirm: false,
    };

    /**
     * Validate first name field
     * @param {HTMLInputElement} field - The field to validate
     * @param {HTMLFormElement} form - The form element (optional, for context)
     */
    _validateFirstName(field, form = null) {
        this.errors.firstName = validate(
            "string",
            {
                field: field,
                rules: {
                    betweenLength: {
                        max: 20,
                        min: 3,
                    },
                    notContainDigits: true,
                },
            },
            form
        );
    }

    /**
     * Validate last name field
     * @param {HTMLInputElement} field - The field to validate
     * @param {HTMLFormElement} form - The form element (optional, for context)
     */
    _validateLastName(field, form = null) {
        this.errors.lastName = validate(
            "string",
            {
                field: field,
                rules: {
                    betweenLength: {
                        max: 20,
                        min: 3,
                    },
                    notContainDigits: true,
                },
            },
            form
        );
    }

    /**
     * Validate email field
     * @param {HTMLInputElement} field - The field to validate
     * @param {HTMLFormElement} form - The form element (optional, for context)
     */
    _validateEmail(field, form = null) {
        this.errors.email = validate("email", { field: field }, form);
    }

    /**
     * Validate password field
     * @param {HTMLInputElement} field - The field to validate
     * @param {HTMLFormElement} form - The form element (optional, for context)
     */
    _validatePassword(field, form = null) {
        this.errors.password = validate("password", { field: field }, form);
    }

    /**
     * Validate password confirm field
     * @param {HTMLInputElement} field - The field to validate
     * @param {HTMLFormElement} form - The form element (optional, for context)
     */
    _validatePasswordConfirm(field, form = null) {
        const passwordField = form ? form.querySelector("#password") : null;
        const passwordValue =
            passwordField && passwordField instanceof HTMLInputElement ? passwordField.value : this.password;
        this.errors.passwordConfirm = validate(
            "string",
            {
                field: field,
                rules: {
                    confirm: passwordValue,
                },
            },
            form
        );
    }

    /**
     * Validate confirm checkbox
     * @param {HTMLInputElement} field - The field to validate
     * @param {HTMLFormElement} form - The form element (optional, for context)
     */
    _validateConfirm(field, form = null) {
        this.errors.confirm = validate(
            "string",
            {
                field: field,
                rules: {
                    checked: true,
                },
            },
            form
        );
    }

    // Public methods for event handlers
    checkEmail(event) {
        const field = /** @type {HTMLInputElement} */ (event.target);
        const form = field.closest("form");
        this._validateEmail(field, form);
    }

    checkFirstName(event) {
        const field = /** @type {HTMLInputElement} */ (event.target);
        const form = field.closest("form");
        this._validateFirstName(field, form);
    }

    checkLastName(event) {
        const field = /** @type {HTMLInputElement} */ (event.target);
        const form = field.closest("form");
        this._validateLastName(field, form);
    }

    checkConfirm(event) {
        const field = /** @type {HTMLInputElement} */ (event.target);
        const form = field.closest("form");
        this._validateConfirm(field, form);
    }

    /**
     * Submit the form with validation
     * @param {Event} event - The event object
     * @returns {void|boolean} - Submit the form if valid, return false otherwise
     */
    submit(event) {
        // @ts-ignore - event.target is HTMLElement in runtime
        const form = event.target.closest("form");

        // Validate all fields before submit
        const firstNameField = form.querySelector("#first_name");
        if (firstNameField) {
            this._validateFirstName(firstNameField, form);
        }

        const lastNameField = form.querySelector("#last_name");
        if (lastNameField) {
            this._validateLastName(lastNameField, form);
        }

        const emailField = form.querySelector("#email");
        if (emailField) {
            this._validateEmail(emailField, form);
        }

        const passwordField = form.querySelector("#password");
        if (passwordField) {
            this._validatePassword(passwordField, form);
        }

        const passwordConfirmField = form.querySelector("#password_confirm");
        if (passwordConfirmField) {
            this._validatePasswordConfirm(passwordConfirmField, form);
        }

        const confirmField = form.querySelector("#confirm");
        if (confirmField) {
            this._validateConfirm(confirmField, form);
        }

        this.inValid = this.validate();
        if (!this.inValid) {
            form.submit();
        }
    }
}
